 // Exercise database - each exercise contains name, description, equipment needed, duration, target areas
 const exerciseDatabase = [
    {
      id: 1,
      name: 'The Hundred',
      description: 'Lie on your back with legs in tabletop position. Pump arms up and down while breathing in for 5 and out for 5.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Keep arms alongside body if wrists are sensitive',
        back: 'Keep head down and legs higher if you have back issues',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion for arm pumps',
        pregnancy: 'After first trimester, perform with legs in tabletop position',
        balance: 'No specific modification needed'
      },
      image: '🧘‍♀️'
    },
    {
      id: 2,
      name: 'Roll Up',
      description: 'Start lying on your back, arms extended overhead. Roll up to seated position one vertebra at a time.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Bend knees or skip this exercise if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Keep arms forward instead of overhead if shoulders are tight',
        pregnancy: 'Perform with knees bent and use hands for support',
        balance: 'No specific modification needed'
      },
      image: '🧍‍♀️'
    },
    {
      id: 3,
      name: 'Single Leg Circles',
      description: 'Lie on your back, one leg extended to ceiling. Circle leg in controlled motion in both directions.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'legs', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Smaller circles and keep opposite knee bent',
        knee: 'Avoid if you have acute knee pain',
        shoulder: 'No specific modification needed',
        pregnancy: 'Keep circles smaller and both knees bent if needed',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 4,
      name: 'Rolling Like a Ball',
      description: 'Balance on your sit bones, knees to chest, and roll back and forth maintaining a C-curve shape.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Keep hands on sides of knees rather than underneath',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Practice balancing before rolling'
      },
      image: '⚪'
    },
    {
      id: 5,
      name: 'Single Leg Stretch',
      description: 'Lie on your back in crunch position, alternate extending one leg while hugging the other to your chest.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'legs'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Rest head in hands if neck/shoulder tension occurs',
        back: 'Keep head down and legs higher',
        knee: 'Smaller range of motion if knees are sensitive',
        shoulder: 'Keep head down if neck/shoulder tension occurs',
        pregnancy: 'Keep both knees bent and head down after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🧎‍♀️'
    },
    {
      id: 6,
      name: 'Double Leg Stretch',
      description: 'Start in crunch position, arms hugging knees. Extend arms and legs simultaneously, then return to start.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'arms', 'legs'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Keep arms lower if wrists are sensitive',
        back: 'Keep legs higher and range of motion smaller',
        knee: 'No specific modification needed',
        shoulder: 'Keep arms lower and closer to body',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '✨'
    },
    {
      id: 7,
      name: 'Spine Stretch Forward',
      description: 'Sit tall with legs extended, reach forward keeping your back straight, then roll down one vertebra at a time.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['back', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Sit on cushion and bend knees slightly',
        knee: 'Bend knees if hamstrings are tight',
        shoulder: 'Keep arms lower if shoulders are tight',
        pregnancy: 'Sit with legs apart to make room for belly',
        balance: 'Sit against wall for support if needed'
      },
      image: '⤵️'
    },
    {
      id: 8,
      name: 'Saw',
      description: 'Sit with legs wide apart, twist upper body and reach opposite hand to opposite foot.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Twist less deeply if you have back issues',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Smaller range of motion for arms',
        pregnancy: 'Sit elevated and twist less deeply',
        balance: 'Sit against wall for support if needed'
      },
      image: '🪚'
    },
    {
      id: 9,
      name: 'Swan Dive',
      description: 'Lie on stomach, lift chest and legs off mat. Rock forward and back in controlled motion.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['back', 'glutes'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain or try Swan Prep instead',
        knee: 'No specific modification needed',
        shoulder: 'Keep arms closer to body',
        pregnancy: 'Not recommended',
        balance: 'No specific modification needed'
      },
      image: '🦢'
    },
    {
      id: 10,
      name: 'Side Kicks',
      description: 'Lie on your side, support head with hand. Kick top leg forward and back in controlled motions.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head on arm rather than hand',
        back: 'Keep range of motion smaller',
        knee: 'Smaller kicks if knees are sensitive',
        shoulder: 'Rest head on arm or pillow if shoulders are tight',
        pregnancy: 'Place pillow under belly if needed',
        balance: 'Lean back against wall for support'
      },
      image: '🦵'
    },
    {
      id: 11,
      name: 'Teaser',
      description: 'Lie on back, roll up to V-position with legs extended at 45 degrees. Hold, then roll back down.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'legs'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Keep arms alongside body instead of overhead',
        pregnancy: 'Not recommended',
        balance: 'Try one leg at a time version first'
      },
      image: '🔺'
    },
    {
      id: 12,
      name: 'Seal',
      description: 'Balance on your tailbone, clasping ankles. Roll back and forth, clapping feet 3 times in each position.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'No specific modification needed',
        pregnancy: 'Not recommended',
        balance: 'Practice balancing before rolling'
      },
      image: '🦭'
    },
    {
      id: 13,
      name: 'Reformer Footwork',
      description: 'Lie on reformer with feet against footbar. Press legs out and in with different foot positions.',
      equipment: ['reformer'],
      duration: 4,
      targetAreas: ['legs', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Use higher spring tension for support',
        knee: 'Avoid full extension if knees are sensitive',
        shoulder: 'Use neck pillow if needed',
        pregnancy: 'Adjust footbar position for comfort',
        balance: 'No specific modification needed'
      },
      image: '🦿'
    },
    {
      id: 14,
      name: 'Reformer Hundred',
      description: 'Similar to mat Hundred but using the reformer springs for added resistance.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter spring tension for arms',
        back: 'Keep head down and legs higher',
        knee: 'No specific modification needed',
        shoulder: 'Use lighter spring tension or smaller arm movements',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '💯'
    },
    {
      id: 15,
      name: 'Short Box Series',
      description: 'Sit on box facing front of reformer, perform various spinal movements with feet secured.',
      equipment: ['reformer'],
      duration: 5,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Avoid deep flexion if you have back issues',
        knee: 'No specific modification needed',
        shoulder: 'Keep arms closer to body for twists',
        pregnancy: 'Use wider strap positioning and avoid deep flexion',
        balance: 'Hold sides of box for additional support'
      },
      image: '📦'
    },
    {
      id: 16,
      name: 'Long Stretch',
      description: 'In plank position with feet on footbar, press carriage out and in using core control.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'arms', 'fullbody'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Place hands on bar instead of reformer if wrists are sensitive',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Use more spring tension for support',
        pregnancy: 'Not recommended',
        balance: 'Use higher spring tension for more stability'
      },
      image: '📏'
    },
    {
      id: 17,
      name: 'Ball Bridge',
      description: 'Lie on back with feet on exercise ball. Lift hips and lower in controlled motion.',
      equipment: ['ball'],
      duration: 3,
      targetAreas: ['core', 'glutes', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Smaller range of motion or use wall for ball stability',
        knee: 'Place ball closer to body if knees are sensitive',
        shoulder: 'No specific modification needed',
        pregnancy: 'Use caution or skip after second trimester',
        balance: 'Place ball against wall for stability'
      },
      image: '⚽'
    },
    {
      id: 18,
      name: 'Ball Roll Out',
      description: 'Kneel behind ball with hands on ball. Roll ball forward and back maintaining plank position.',
      equipment: ['ball'],
      duration: 3,
      targetAreas: ['core', 'arms', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Place forearms on ball instead of hands',
        back: 'Smaller range of motion',
        knee: 'Use a soft pad under knees',
        shoulder: 'Smaller range of motion',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Start with ball against wall'
      },
      image: '🔄'
    },
    {
      id: 19,
      name: 'Ball Pike',
      description: 'Start in plank position with feet on ball. Pike hips up bringing ball toward hands.',
      equipment: ['ball'],
      duration: 3,
      targetAreas: ['core', 'arms', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Use push-up handles if wrists are sensitive',
        back: 'Smaller range of motion or skip',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion',
        pregnancy: 'Not recommended',
        balance: 'Practice stability first before adding pike movement'
      },
      image: '⛰️'
    },
    {
      id: 20,
      name: 'Band Arm Work',
      description: 'Hold resistance band with both hands, perform various arm movements for resistance training.',
      equipment: ['band'],
      duration: 4,
      targetAreas: ['arms', 'back'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Use lighter resistance band',
        back: 'Avoid excessive twisting',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion and lighter band',
        pregnancy: 'Stand instead of seated if more comfortable',
        balance: 'Sit or stand near wall for support'
      },
      image: '💪'
    },
    {
      id: 21,
      name: 'Band Leg Press',
      description: 'Lie on back, loop band around foot and press leg to ceiling against resistance.',
      equipment: ['band'],
      duration: 3,
      targetAreas: ['legs', 'glutes'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep opposite knee bent and foot on floor',
        knee: 'Use lighter resistance or avoid full extension',
        shoulder: 'No specific modification needed',
        pregnancy: 'Adjust leg position for comfort',
        balance: 'No specific modification needed'
      },
      image: '🦿'
    },
    {
      id: 22,
      name: 'Ring Pushups',
      description: 'Place ring between palms in push-up position, squeeze ring while performing push-ups.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Skip if wrists are very sensitive',
        back: 'Perform from knees instead of full plank',
        knee: 'Perform from knees instead of full plank',
        shoulder: 'Lower range of motion or skip if shoulders are painful',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Perform against wall at an incline'
      },
      image: '⭕'
    },
    {
      id: 23,
      name: 'Inner Thigh Squeeze',
      description: 'Place ring between knees in bridge position, squeeze and release.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['legs', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep hips lower in bridge',
        knee: 'Place ring higher between thighs if knees are sensitive',
        shoulder: 'No specific modification needed',
        pregnancy: 'Adjust bridge height for comfort',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 24,
      name: 'Arm Circles',
      description: 'Hold light weights, extend arms to sides and make small, controlled circles.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['arms', 'shoulders'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Use lighter weights or no weights',
        back: 'No specific modification needed',
        knee: 'No specific modification needed',
        shoulder: 'Smaller circles and lighter weights',
        pregnancy: 'Use lighter weights',
        balance: 'Sit or stand near wall for support'
      },
      image: '⚪'
    },
    {
      id: 25,
      name: 'Weighted Hundred',
      description: 'Perform the Hundred exercise while holding light weights for added challenge.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['core', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weights or skip weights',
        back: 'Keep head down and legs higher',
        knee: 'No specific modification needed',
        shoulder: 'Use lighter weights or skip weights',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '💯'
    },
    {
      id: 26,
      name: 'Foam Roller Spine Stretch',
      description: 'Sit on mat with foam roller behind back, roll down and up for spinal mobility.',
      equipment: ['foam_roller'],
      duration: 3,
      targetAreas: ['back', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Smaller range of motion and gentler pressure',
        knee: 'No specific modification needed',
        shoulder: 'No specific modification needed',
        pregnancy: 'Adjust position for comfort or skip',
        balance: 'Place roller against wall'
      },
      image: '📏'
    },
    {
      id: 27,
      name: 'Foam Roller Balance',
      description: 'Sit on foam roller, find balance point, and perform various leg movements.',
      equipment: ['foam_roller'],
      duration: 3,
      targetAreas: ['core', 'balance'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'No specific modification needed',
        pregnancy: 'Not recommended',
        balance: 'Start near a wall or chair for support'
      },
      image: '⚖️'
    },
    {
      id: 28,
      name: 'Scissors',
      description: 'Lie on back with legs extended to ceiling, alternate scissor movements with straight legs.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'legs', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head with towel if neck/shoulder tension occurs',
        back: 'Bend knees slightly',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Keep head down if neck/shoulder tension occurs',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '✂️'
    },
    {
      id: 29,
      name: 'Bicycle',
      description: 'Lie on back in crunch position, alternate bringing opposite elbow to opposite knee.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'legs'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Support head with towel if neck/shoulder tension occurs',
        back: 'Smaller range of motion',
        knee: 'Gentle movements if knees are sensitive',
        shoulder: 'Support head with towel if neck/shoulder tension occurs',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🚲'
    },
    {
      id: 30,
      name: 'Plank Variations',
      description: 'Hold plank position and perform various modifications like leg lifts or shoulder taps.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'arms', 'fullbody'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Perform from forearms instead of hands',
        back: 'From knees instead of full plank',
        knee: 'From knees instead of full plank',
        shoulder: 'Perform from forearms if shoulders are sensitive',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Start with wall plank at an incline'
      },
      image: '📏'
    },
    {
      id: 31,
      name: 'Chair Push-ups',
      description: 'Stand facing chair with hands on pedal. Lower pedal down and press back up using arm and core strength.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['arms', 'core', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position or use handles if available',
        back: 'Smaller range of motion',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion if shoulders are sensitive',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Stand closer to chair for more stability'
      },
      image: '🪑'
    },
    {
      id: 32,
      name: 'Pike on Chair',
      description: 'Sit on chair edge, hands on pedal. Press pedal down while extending legs to pike position.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['core', 'legs', 'arms'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Use handles if available',
        back: 'Smaller range of motion or skip',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Use higher spring setting for more support',
        pregnancy: 'Not recommended',
        balance: 'Use higher spring setting for more stability'
      },
      image: '⛰️'
    },
    {
      id: 33,
      name: 'Chair Mermaid',
      description: 'Sit side-saddle on chair, one hand on pedal. Press pedal down while performing side stretch.',
      equipment: ['chair'],
      duration: 2,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position or use handle',
        back: 'Smaller range of motion',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion and avoid if painful',
        pregnancy: 'Adjust position for comfort',
        balance: 'Use higher spring setting for stability'
      },
      image: '🧜‍♀️'
    },
    {
      id: 34,
      name: 'Chair Mountain Climber',
      description: 'Start in plank position with feet on chair. Alternate bringing knees toward chest.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['core', 'legs', 'fullbody'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Perform on forearms instead of hands',
        back: 'Slower pace or skip',
        knee: 'Slower pace if knees are sensitive',
        shoulder: 'Skip if shoulders are painful',
        pregnancy: 'Not recommended',
        balance: 'Start with stationary plank before adding movement'
      },
      image: '⛰️'
    },
    {
      id: 35,
      name: 'Standing Leg Pumps',
      description: 'Stand facing chair, one foot on pedal. Pump pedal down and up with controlled leg movements.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Stand taller and maintain neutral spine',
        knee: 'Smaller range of motion if knees are sensitive',
        shoulder: 'No specific modification needed',
        pregnancy: 'Hold stable support for balance',
        balance: 'Hold onto a stable support'
      },
      image: '🦵'
    },
    {
      id: 36,
      name: 'Tower Roll Back',
      description: 'Sit facing tower, holding roll-down bar. Roll back maintaining C-curve spine, then return to seated.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'back', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on bar',
        back: 'Smaller range of motion or skip if acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Wider grip on bar',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🏗️'
    },
    {
      id: 37,
      name: 'Tower Leg Springs',
      description: 'Lie on back with feet in tower straps. Perform controlled leg circles and scissors.',
      equipment: ['tower'],
      duration: 4,
      targetAreas: ['legs', 'core', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep range of motion smaller',
        knee: 'Adjust strap position if knees are sensitive',
        shoulder: 'No specific modification needed',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 38,
      name: 'Hanging Pull-ups',
      description: 'Hold tower roll-down bar overhead. Perform pull-ups with body in diagonal position.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['arms', 'back', 'core'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust grip on bar',
        back: 'Skip if you have acute back pain',
        knee: 'No specific modification needed',
        shoulder: 'Skip if shoulders are painful',
        pregnancy: 'Not recommended',
        balance: 'Use higher spring setting for more support'
      },
      image: '💪'
    },
    {
      id: 39,
      name: 'Tower Side Splits',
      description: 'Lie on side with top leg in tower strap. Lift and lower leg with controlled movements.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Support lower back with small towel roll if needed',
        knee: 'Skip if knee pain is present',
        shoulder: 'Support head with pillow if needed',
        pregnancy: 'Adjust for comfort or skip after second trimester',
        balance: 'No specific modification needed'
      },
      image: '↔️'
    },
    {
      id: 40,
      name: 'Tower Breathing',
      description: 'Sit with back against tower, arms in straps. Focus on expanding ribcage with deep breaths while pressing arms out.',
      equipment: ['tower'],
      duration: 2,
      targetAreas: ['core', 'arms', 'back'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust strap position on arms',
        back: 'Use cushion for support if needed',
        knee: 'No specific modification needed',
        shoulder: 'Smaller range of motion',
        pregnancy: 'Adjust position for comfort',
        balance: 'No specific modification needed'
      },
      image: '🫁'
    },
    {
      id: 41,
      name: 'Criss-Cross',
      description: 'Lie on your back in crunch position with hands behind head, alternate twisting to bring elbow to opposite knee.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'obliques'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep movements smaller and focus on rotation rather than height',
        knee: 'Keep knees higher if hamstrings are tight',
        shoulder: 'Support head in hands with elbows wide or keep head down',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🔄'
    },
    {
      id: 42,
      name: 'Corkscrew',
      description: 'Lie on your back with legs extended to ceiling. Circle both legs together in a controlled movement, making a large circle.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Make smaller circles or skip if back pain present',
        knee: 'Modify range of motion to avoid strain',
        shoulder: 'Keep arms and shoulders anchored firmly to mat',
        pregnancy: 'Not recommended',
        balance: 'No specific modification needed'
      },
      image: '🌀'
    },
    {
      id: 43,
      name: 'Open Leg Rocker',
      description: 'Balance on your sit bones with legs in a V-shape, hands holding ankles. Roll back and forth maintaining the V-shape.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'Keep knees slightly bent if hamstrings are tight',
        shoulder: 'No specific modification needed',
        pregnancy: 'Not recommended',
        balance: 'Practice finding balance point before rolling'
      },
      image: '🛹'
    },
    {
      id: 44,
      name: 'Neck Pull',
      description: 'Begin seated with legs extended, roll back articulating spine and then roll up with head and arms pulling forward.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Use hands behind thighs for support or skip if back pain present',
        knee: 'Bend knees if hamstrings are tight',
        shoulder: 'Avoid pulling with neck, focus on abdominal engagement',
        pregnancy: 'Not recommended',
        balance: 'Perform against a wall for support'
      },
      image: '⤴️'
    },
    {
      id: 45,
      name: 'Shoulder Bridge',
      description: 'Lie on your back with knees bent, lift hips to create a straight line from shoulders to knees, then articulate spine back down.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['glutes', 'back', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce height of bridge if uncomfortable',
        knee: 'Adjust foot position for knee comfort',
        shoulder: 'Place arms slightly away from sides for stability',
        pregnancy: 'Safe during early pregnancy, use caution in later stages',
        balance: 'Keep feet hip-width apart for stability'
      },
      image: '🌉'
    },
    {
      id: 46,
      name: 'Leg Pull Front',
      description: 'Start in plank position, alternately lift and lower each leg while maintaining stable shoulders and core.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'arms', 'glutes'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Perform on forearms instead of hands',
        back: 'Keep hips level and avoid swaying',
        knee: 'Reduce range of motion if needed',
        shoulder: 'Keep shoulders directly over wrists with firm engagement',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Keep both feet on ground until core stability improves'
      },
      image: '🏋️'
    },
    {
      id: 47,
      name: 'Leg Pull Back',
      description: 'Start in reverse plank position (facing ceiling), alternately lift and lower each leg while maintaining alignment.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'arms', 'glutes', 'back'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust wrist angle or perform seated version',
        back: 'Keep hips lifted with firm core engagement',
        knee: 'Reduce range of motion if needed',
        shoulder: 'Bend elbows slightly if shoulders are sensitive',
        pregnancy: 'Not recommended',
        balance: 'Start with both feet on floor and progress to lifting'
      },
      image: '🔙'
    },
    {
      id: 48,
      name: 'Side Kick Kneeling',
      description: 'Kneel on one knee with other leg extended to side. Swing extended leg forward and back with control.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use fist instead of flat hand if wrists are sensitive',
        back: 'Maintain neutral spine throughout',
        knee: 'Place cushion under supporting knee',
        shoulder: 'Keep supporting shoulder engaged and away from ear',
        pregnancy: 'Reduce range or skip in later stages',
        balance: 'Place hand on wall for support if needed'
      },
      image: '🦵'
    },
    {
      id: 49,
      name: 'Boomerang',
      description: 'Begin seated, roll back with legs overhead, then return to seated position with a forward reach.',
      equipment: ['none'],
      duration: 3,
      targetAreas: ['core', 'flexibility', 'back'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Skip if you have acute back pain',
        knee: 'Bend knees throughout if hamstrings are tight',
        shoulder: 'Keep neck relaxed and focus on abdominal control',
        pregnancy: 'Not recommended',
        balance: 'Practice roll-back movements separately before combining'
      },
      image: '🪃'
    },
    {
      id: 50,
      name: 'Seal with a Clap',
      description: 'Balance on tailbone, holding ankles with legs in a tight ball. Roll back and clap feet together three times behind you.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce rolling range if back is sensitive',
        knee: 'Hold behind knees instead of ankles if needed',
        shoulder: 'No specific modification needed',
        pregnancy: 'Not recommended',
        balance: 'Practice finding balance point before adding claps'
      },
      image: '👏'
    },
    {
      id: 51,
      name: 'Rocking',
      description: 'Lie on stomach with arms and legs extended, lift limbs and rock forward and back on abdomen.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['back', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce height of limbs or skip if back pain is present',
        knee: 'Reduce leg height if knees are uncomfortable',
        shoulder: 'Keep neck in line with spine, gaze down',
        pregnancy: 'Not recommended',
        balance: 'Start with smaller rocking movements'
      },
      image: '🔄'
    },
    {
      id: 52,
      name: 'Control Balance',
      description: 'Balance on tailbone with legs and arms extended in front, moving in teeter-totter motion with control.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'balance'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep knees bent if back is sensitive',
        knee: 'No specific modification needed',
        shoulder: 'Keep shoulders relaxed away from ears',
        pregnancy: 'Not recommended',
        balance: 'Keep feet on floor initially until stability improves'
      },
      image: '⚖️'
    },
    {
      id: 53,
      name: 'Push-Up',
      description: 'Start in plank position. Bend elbows to lower body with control, maintaining straight line from head to heels, then push back up.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['arms', 'core', 'chest'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Perform on fists or with pushup handles',
        back: 'Keep abdominals engaged and avoid sagging hips',
        knee: 'Perform from knees rather than toes',
        shoulder: 'Reduce depth of pushup to avoid pain',
        pregnancy: 'Perform incline pushups in later stages',
        balance: 'Start with hands on elevated surface for more stability'
      },
      image: '💪'
    },
    {
      id: 54,
      name: 'Crab',
      description: 'Start seated with hands behind you and knees bent. Lift hips into reverse table top, then thread one arm under body while rotating.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['arms', 'core', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Limit range of motion or skip if wrists are very sensitive',
        back: 'Keep hips lower and movements smaller',
        knee: 'Keep weight distributed evenly to reduce knee strain',
        shoulder: 'Reduce range of rotation if shoulders are tight',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Start with just lifting hips without threading arm'
      },
      image: '🦀'
    },
    {
      id: 55,
      name: 'Mermaid',
      description: 'Sit with legs folded to one side, extend arm overhead and stretch laterally, creating a long curve with the body.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['flexibility', 'obliques', 'back'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce range of side bend if back is sensitive',
        knee: 'Adjust leg position for comfort',
        shoulder: 'Keep shoulders relaxed, use wall for support if needed',
        pregnancy: 'Adjust position to make room for belly',
        balance: 'Use wall for support if needed'
      },
      image: '🧜‍♀️'
    },
    {
      id: 56,
      name: 'Hip Circles',
      description: 'Lie on back with legs in tabletop position. Draw large circles with the knees while keeping lower back stable.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'flexibility', 'hips'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Make smaller circles and keep back firmly pressed to mat',
        knee: 'Adjust range to avoid knee discomfort',
        shoulder: 'No specific modification needed',
        pregnancy: 'Safe in early pregnancy; reduce range in later stages',
        balance: 'No specific modification needed'
      },
      image: '⭕'
    },
    {
      id: 57,
      name: 'Side Bend',
      description: 'Start seated with legs together extended to side. Place one hand on floor, lift hips and extend opposite arm overhead.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['obliques', 'arms', 'core'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Use fist or forearm support instead of flat hand',
        back: 'Keep movement smaller and more controlled',
        knee: 'No specific modification needed',
        shoulder: 'Keep supporting shoulder away from ear',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Practice seated side stretch first before lifting'
      },
      image: '↪️'
    },
    {
      id: 58,
      name: 'Jackknife',
      description: 'Lie on back with arms and legs extended. Simultaneously lift torso and legs to touch toes, forming a V-shape.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Bend knees or skip if back pain is present',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Keep neck aligned with spine, avoid pulling with arms',
        pregnancy: 'Not recommended',
        balance: 'Roll up with bent knees first, then progress to straight legs'
      },
      image: '📐'
    },
    {
      id: 59,
      name: 'Swimming',
      description: 'Lie on stomach with arms and legs extended. Lift opposite arm and leg, alternating in a swimming motion.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['back', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Lift limbs lower if back is sensitive',
        knee: 'Reduce leg lift height if needed',
        shoulder: 'Keep neck in line with spine, look down',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Start by lifting just arms, then just legs, before combining'
      },
      image: '🏊'
    },
    {
      id: 60,
      name: 'Standing Roll Down',
      description: 'Stand with feet hip-width apart. Roll down through spine one vertebra at a time, then roll back up with control.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['back', 'flexibility', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Bend knees and reduce range of motion',
        knee: 'Keep knees soft throughout movement',
        shoulder: 'Let arms hang naturally, avoid tension',
        pregnancy: 'Widen stance in later stages; reduce range',
        balance: 'Stand near wall for support if needed'
      },
      image: '⤵️'
    },
    {
      id: 61,
      name: 'Pelvic Curl',
      description: 'Lie on back with knees bent, feet flat. Tilt pelvis to flatten back, then curl spine off mat one vertebra at a time, creating a bridge.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core', 'back', 'glutes'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce height of curl if back is sensitive',
        knee: 'Position feet for knee comfort, possibly wider',
        shoulder: 'Keep arms relaxed at sides with palms down',
        pregnancy: 'Safe during early pregnancy, adjust in later stages',
        balance: 'No specific modification needed'
      },
      image: '🌊'
    },
    {
      id: 62,
      name: 'Chest Lift',
      description: 'Lie on back with knees bent. Place hands behind head, engage abdominals to lift head, neck and shoulders off mat.',
      equipment: ['none'],
      duration: 2,
      targetAreas: ['core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Lift just head and shoulders, not full upper back',
        knee: 'No specific modification needed',
        shoulder: 'Support head lightly, don\'t pull with hands',
        pregnancy: 'Perform with diagonal reach in later stages',
        balance: 'No specific modification needed'
      },
      image: '🔼'
    },
    {
      id: 63,
      name: 'Chest Expansion',
      description: 'Stand or kneel tall, extend arms forward at shoulder height. Pull arms back in rowing motion while rotating head.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['arms', 'back', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust band grip for comfort',
        back: 'Maintain strong upright posture',
        knee: 'Sit instead of kneel if knees are uncomfortable',
        shoulder: 'Reduce range of motion, use lighter resistance',
        pregnancy: 'Safe with proper posture and band tension',
        balance: 'Sit or stand near wall if balance is challenging'
      },
      image: '🏹'
    },
    {
      id: 64,
      name: 'Snake/Twist',
      description: 'On the reformer, kneel facing side with one hand on foot bar. Press carriage out while rotating spine into a twist.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'obliques', 'arms'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust hand position on footbar',
        back: 'Reduce rotation range if back is sensitive',
        knee: 'Use padding under knees',
        shoulder: 'Engage shoulder blades and avoid shrugging',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use lighter spring tension for more control'
      },
      image: '🐍'
    },
    {
      id: 65,
      name: 'Elephant',
      description: 'On the reformer, stand facing foot bar in pike position with hands on bar. Press carriage back and forth with straight legs.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'legs', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position or use handles',
        back: 'Keep slight bend in knees and hinge from hips',
        knee: 'Maintain soft bend in knees throughout',
        shoulder: 'Keep shoulders actively engaged away from ears',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Use heavier spring tension for stability'
      },
      image: '🐘'
    },
    {
      id: 66,
      name: 'Knee Stretches',
      description: 'On the reformer, kneel facing foot bar with hands on bar. Round and arch back while pressing carriage back and forth.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use hands on handles rather than foot bar',
        back: 'Reduce range of spinal flexion/extension',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulders engaged and away from ears',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use appropriate spring tension for control'
      },
      image: '🧎'
    },
    {
      id: 67,
      name: 'Stomach Massage Series',
      description: 'Sit on reformer facing foot bar with feet on bar. Perform variations including flat, round and twist while pressing carriage.',
      equipment: ['reformer'],
      duration: 4,
      targetAreas: ['core', 'legs', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Hold sides of reformer rather than placing hands behind',
        back: 'Maintain strong core engagement throughout',
        knee: 'Position feet for knee comfort',
        shoulder: 'Keep shoulders down away from ears',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use appropriate spring tension for stability'
      },
      image: '🧘'
    },
    {
      id: 68,
      name: 'Thigh Stretch',
      description: 'Kneel on reformer carriage facing away from foot bar. Hold straps overhead, press back to full extension, then return with control.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['legs', 'core', 'arms'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust strap grip for comfort',
        back: 'Maintain neutral spine, don\'t arch',
        knee: 'Use additional padding under knees',
        shoulder: 'Bring arms to shoulder height instead of overhead if needed',
        pregnancy: 'Not recommended',
        balance: 'Use appropriate spring tension for control'
      },
      image: '🦵'
    },
    {
      id: 69,
      name: 'Knee Folds',
      description: 'Lie on back with one foot on bar and other leg in tabletop. Fold knee toward chest while pressing out with other leg.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'legs'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep back firmly pressed into carriage',
        knee: 'Adjust foot bar position for comfort',
        shoulder: 'Keep shoulders relaxed on carriage',
        pregnancy: 'Safe in early pregnancy with adjusted position',
        balance: 'Use appropriate spring tension for stability'
      },
      image: '📎'
    },
    {
      id: 70,
      name: 'Front Splits',
      description: 'On reformer, place one foot on foot bar and extend opposite leg straight on carriage. Press out and in for hamstring stretch.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['flexibility', 'legs'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep hips square and spine neutral',
        knee: 'Bend extended leg slightly if needed',
        shoulder: 'Keep shoulders relaxed on carriage',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Hold reformer frame for stability if needed'
      },
      image: '↔️'
    },
    {
      id: 71,
      name: 'Side Splits',
      description: 'Stand on reformer with one foot on each side of foot bar. Press out to wide stance then pull back with inner thighs.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['legs', 'inner thighs', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Maintain neutral spine throughout',
        knee: 'Keep knees tracking over toes',
        shoulder: 'Hold straps for balance if available',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Use appropriate spring tension and hold frame if needed'
      },
      image: '⇔'
    },
    {
      id: 72,
      name: 'Russian Splits',
      description: 'Face side of reformer, place outside leg on foot bar, inside leg on carriage. Press carriage out for inner thigh and hamstring stretch.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['flexibility', 'legs', 'core'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Adjust range of motion for knee comfort',
        shoulder: 'Use reformer for stable support',
        pregnancy: 'Not recommended',
        balance: 'Hold onto reformer frame for stability'
      },
      image: '🪆'
    },
    {
      id: 73,
      name: 'Up Stretch',
      description: 'Start in plank position facing reformer foot bar. Press carriage away with straight body, then pike hips to form inverted V.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'arms', 'back', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust hand position or use handle bar if available',
        back: 'Reduce range of motion in pike position',
        knee: 'Bend knees slightly in pike if hamstrings are tight',
        shoulder: 'Keep shoulders engaged and stable',
        pregnancy: 'Not recommended',
        balance: 'Use appropriate spring tension for control'
      },
      image: '⤴️'
    },
    {
      id: 74,
      name: 'Down Stretch',
      description: 'Start in plank on reformer with feet in straps. Control carriage movement while maintaining straight body alignment.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['core', 'arms', 'back'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Perform on forearms if wrists are sensitive',
        back: 'Keep hips level and core firmly engaged',
        knee: 'No specific modification needed',
        shoulder: 'Keep shoulders stacked over wrists',
        pregnancy: 'Not recommended',
        balance: 'Use appropriate spring tension for stability'
      },
      image: '⤵️'
    },
    {
      id: 75,
      name: 'Star',
      description: 'Lie on side on tower/cadillac with bottom leg fixed in loop, top leg in top loop. Open legs against spring resistance.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['legs', 'inner thighs', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Adjust leg strap position for comfort',
        shoulder: 'Support head with arm or pillow if needed',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use appropriate spring tension for control'
      },
      image: '✨'
    },
    {
      id: 76,
      name: 'Monkey',
      description: 'Hang from tower/cadillac push-through bar, perform controlled leg movements while suspended upside down.',
      equipment: ['tower'],
      duration: 4,
      targetAreas: ['core', 'arms', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Ensure secure grip on bar',
        back: 'Skip if back issues are present',
        knee: 'No specific modification needed',
        shoulder: 'Ensure shoulders are properly warmed up',
        pregnancy: 'Not recommended',
        balance: 'Have instructor spotting for safety'
      },
      image: '🐒'
    },
    {
      id: 77,
      name: 'Tower Push Through',
      description: 'Lie on back under tower/cadillac push-through bar. Press bar up and over face with straight arms, controlling its path.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'arms', 'chest'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on bar for comfort',
        back: 'Keep lower back in contact with mat',
        knee: 'No specific modification needed',
        shoulder: 'Reduce range if shoulder mobility is limited',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Have instructor spot for safety initially'
      },
      image: '🏋️'
    },
    {
      id: 78,
      name: 'Roll Back Bar',
      description: 'Sit facing tower/cadillac, holding roll-back bar. Roll spine back with control, then return to seated position.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'back', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on bar for comfort',
        back: 'Reduce rolling range if back is sensitive',
        knee: 'Sit on cushion if hamstrings are tight',
        shoulder: 'Keep shoulders down and engage back muscles',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use appropriate spring tension for support'
      },
      image: '🔄'
    },
    {
      id: 79,
      name: 'Tower Spring Scissors',
      description: 'Lie on back with legs in tower/cadillac foot straps. Alternate opening and closing legs in scissor movement against spring resistance.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'legs', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep lower back pressed into mat',
        knee: 'Adjust strap position for knee comfort',
        shoulder: 'Keep shoulders relaxed on mat',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '✂️'
    },
    {
      id: 80,
      name: 'Semicircle',
      description: 'Lie on back holding tower/cadillac push-through bar. Circle bar overhead to mat behind you and back with straight arms.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'arms', 'chest', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust grip on bar for comfort',
        back: 'Reduce range of motion if back is sensitive',
        knee: 'No specific modification needed',
        shoulder: 'Skip if shoulder mobility is limited',
        pregnancy: 'Not recommended',
        balance: 'Have instructor spot for safety'
      },
      image: '🌓'
    },
    {
      id: 81,
      name: 'Chair Pike',
      description: 'Stand facing chair, hands on pedal. Press pedal down while lifting hips high into pike position, then return with control.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['core', 'arms', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust hand position for comfort',
        back: 'Reduce range of motion, keeping slight bend in knees',
        knee: 'Maintain soft bend in knees throughout',
        shoulder: 'Engage shoulder blades, avoid shrugging',
        pregnancy: 'Not recommended',
        balance: 'Use appropriate spring setting for stability'
      },
      image: '📐'
    },
    {
      id: 82,
      name: 'Chair Tricep Press',
      description: 'Kneel behind chair facing away, hands on pedal behind you. Press pedal down using triceps while maintaining upright posture.',
      equipment: ['chair'],
      duration: 2,
      targetAreas: ['arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position for comfort',
        back: 'Keep spine neutral, avoid arching',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulders down and back',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Use appropriate spring setting for stability'
      },
      image: '💪'
    },
    {
      id: 83,
      name: 'Standing Leg Circles',
      description: 'Stand sideways to chair, outside hand on chair. Place inside foot on pedal and circle leg with control.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['legs', 'core', 'balance'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust supportive hand position',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Make smaller circles if knee is sensitive',
        shoulder: 'Keep supporting shoulder down and engaged',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Hold chair with both hands if needed'
      },
      image: '⭕'
    },
    {
      id: 84,
      name: 'Chair Swan',
      description: 'Kneel facing chair with hands on pedal. Press pedal down while extending spine into swan position, then return.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['back', 'core', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position for comfort',
        back: 'Reduce range of spinal extension',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulders away from ears',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Use appropriate spring setting for control'
      },
      image: '🦢'
    },
    {
      id: 85,
      name: 'Chair Side Sit-ups',
      description: 'Sit sideways on chair with legs secured, hands behind head. Perform side bend toward floor, then return to upright.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['obliques', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce range of side bend if back is sensitive',
        knee: 'Position legs for comfort',
        shoulder: 'Support head lightly, avoid pulling with hands',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Hold chair for support if needed'
      },
      image: '↪️'
    },
    {
      id: 86,
      name: 'Forward Lunge on Chair',
      description: 'Stand behind chair, one foot on pedal. Press pedal down into lunge position, return with control.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep spine neutral throughout',
        knee: 'Control range to avoid knee strain',
        shoulder: 'Keep shoulders relaxed and down',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Hold onto chair for support'
      },
      image: '🏃'
    },
    {
      id: 87,
      name: 'Chair Cat/Cow',
      description: 'Kneel facing chair with hands on pedal. Alternate rounding and arching spine while controlling pedal movement.',
      equipment: ['chair'],
      duration: 2,
      targetAreas: ['back', 'core', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust hand position for comfort',
        back: 'Reduce range of spinal flexion/extension',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulders engaged and away from ears',
        pregnancy: 'Safe in early pregnancy with reduced range',
        balance: 'Use appropriate spring setting for stability'
      },
      image: '🐱'
    },
    {
      id: 88,
      name: 'Hip Opener with Ball',
      description: 'Lie on back with exercise ball between knees. Squeeze and release ball while performing small circular movements.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['inner thighs', 'core', 'hips'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep lower back pressed into mat',
        knee: 'Use appropriate size ball for knee comfort',
        shoulder: 'Keep shoulders relaxed on mat',
        pregnancy: 'Position ball for comfort in early pregnancy',
        balance: 'No specific modification needed'
      },
      image: '🔄'
    },
    {
      id: 89,
      name: 'Ball Bridge with Leg Extension',
      description: 'Lie on back with feet on exercise ball. Lift hips into bridge, then extend one leg without dropping hips.',
      equipment: ['ball'],
      duration: 3,
      targetAreas: ['core', 'glutes', 'legs'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep hips lower if back is sensitive',
        knee: 'Skip leg extension if knee is uncomfortable',
        shoulder: 'Press arms firmly into mat for support',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Perform bridge without leg extension initially'
      },
      image: '🔝'
    },
    {
      id: 90,
      name: 'Ball Hamstring Curl',
      description: 'Lie on back with heels on exercise ball. Lift hips and pull ball toward you by bending knees, then extend.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['hamstrings', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep hips lower if back is sensitive',
        knee: 'Control range for knee comfort',
        shoulder: 'Press arms firmly into mat for support',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Place ball against wall for initial stability'
      },
      image: '🔄'
    },
    {
      id: 91,
      name: 'Ball Chest Lift with Rotation',
      description: 'Sit on exercise ball with feet flat. Roll down slightly, then lift chest with rotation to each side.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['core', 'obliques'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce range of rolling back',
        knee: 'Position feet securely for support',
        shoulder: 'Keep shoulders relaxed, avoid tension',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'Position near wall for support if needed'
      },
      image: '🔄'
    },
    {
      id: 92,
      name: 'Prone Extension on Ball',
      description: 'Lie prone over exercise ball with feet against wall. Lift chest into spinal extension with arms extended.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['back', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Position hands for comfort',
        back: 'Limit extension if back is sensitive',
        knee: 'Position ball for knee comfort',
        shoulder: 'Keep shoulders away from ears',
        pregnancy: 'Not recommended',
        balance: 'Perform near wall for support'
      },
      image: '⤴️'
    },
    {
      id: 93,
      name: 'Ball Wall Squat',
      description: 'Place exercise ball between lower back and wall. Perform squat while rolling ball up and down wall.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Limit squat depth if back is sensitive',
        knee: 'Control depth based on knee comfort',
        shoulder: 'Keep shoulders relaxed and down',
        pregnancy: 'Safe in early pregnancy, adjust in later stages',
        balance: 'Place hands on thighs for additional support'
      },
      image: '🧍'
    },
    {
      id: 94,
      name: 'Band Seated Row',
      description: 'Sit with legs extended, resistance band around feet. Pull band toward waist with elbows bent, squeezing shoulder blades.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['arms', 'back', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust band grip for comfort',
        back: 'Maintain upright posture with core engaged',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Reduce range of motion if shoulders are sensitive',
        pregnancy: 'Safe with proper positioning',
        balance: 'No specific modification needed'
      },
      image: '🚣'
    },
    {
      id: 95,
      name: 'Band Bicep Curl',
      description: 'Stand with one foot on middle of band, holding ends. Perform bicep curls with controlled resistance.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['arms'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust grip for wrist comfort',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Stand with slight knee bend',
        shoulder: 'Keep shoulders down and back',
        pregnancy: 'Safe with proper positioning',
        balance: 'Perform near wall for support if needed'
      },
      image: '💪'
    },
    {
      id: 96,
      name: 'Band Side-Lying Leg Lift',
      description: 'Lie on side with band around ankles. Lift top leg against band resistance while maintaining alignment.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head with towel under head/arm if needed',
        back: 'Keep spine neutral, avoid rolling forward or back',
        knee: 'Adjust band position for knee comfort',
        shoulder: 'Support head comfortably to avoid neck strain',
        pregnancy: 'Safe in early pregnancy with support',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 97,
      name: 'Band Kneeling Lat Pull',
      description: 'Kneel holding band secured overhead. Pull band down and back, engaging lats and core stabilizers.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['back', 'arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip for wrist comfort',
        back: 'Maintain neutral spine throughout',
        knee: 'Use padding under knees',
        shoulder: 'Reduce range of motion if shoulders are tight',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'Perform near wall for support if needed'
      },
      image: '⬇️'
    },
    {
      id: 98,
      name: 'Band Pallof Press',
      description: 'Stand sideways to secured band, holding at chest height. Press band straight out, resisting rotational force.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['core', 'obliques'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position for comfort',
        back: 'Engage core to protect back',
        knee: 'Stand with soft knees for stability',
        shoulder: 'Reduce range of press if shoulders are sensitive',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'Stand in split stance for stability'
      },
      image: '→'
    },
    {
      id: 99,
      name: 'Side-Lying Clam with Band',
      description: 'Lie on side with legs bent and band around knees. Keep feet together while opening top knee against resistance.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['glutes', 'core', 'hips'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Support head comfortably to avoid wrist strain',
        back: 'Keep spine neutral and hip stacked',
        knee: 'Adjust range of motion for knee comfort',
        shoulder: 'Support head with pillow if needed',
        pregnancy: 'Safe with proper positioning',
        balance: 'No specific modification needed'
      },
      image: '🦪'
    },
    {
      id: 100,
      name: 'Ring Push-Up Variation',
      description: 'Perform push-up with each hand holding a Pilates ring, adding instability challenge for core engagement.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['arms', 'chest', 'core'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust rings to find comfortable angle for wrists',
        back: 'Maintain straight body alignment',
        knee: 'Perform from knees if needed',
        shoulder: 'Reduce depth of push-up for shoulder comfort',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Start with one ring and one hand on stable surface'
      },
      image: '⭕'
    },
    {
      id: 101,
      name: 'Ring Squeeze Chest Press',
      description: 'Lie on back with arms extended, holding ring with both hands. Press ring together while raising arms overhead, then return.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['chest', 'arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust hand position on ring for comfort',
        back: 'Keep lower back pressed into mat',
        knee: 'No specific modification needed',
        shoulder: 'Reduce overhead range if shoulders are tight',
        pregnancy: 'Keep arms in front of body in later stages',
        balance: 'No specific modification needed'
      },
      image: '⭕'
    },
    {
      id: 102,
      name: 'Ring Around the World',
      description: 'Stand holding ring in front of chest. Circle ring around body in horizontal plane, maintaining ring tension.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['arms', 'core', 'back'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on ring for comfort',
        back: 'Keep spine neutral with core engaged',
        knee: 'Stand with soft knees for stability',
        shoulder: 'Reduce range of motion if shoulders are tight',
        pregnancy: 'Safe in early pregnancy with reduced range',
        balance: 'Stand near wall for support if needed'
      },
      image: '🌍'
    },
    {
      id: 103,
      name: 'Inner Thigh Lift with Ring',
      description: 'Lie on side with ring between ankles. Lift bottom leg while maintaining pressure on ring.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['inner thighs', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head comfortably to avoid wrist strain',
        back: 'Keep spine neutral and hips stacked',
        knee: 'Position ring for knee comfort',
        shoulder: 'Support head with pillow if needed',
        pregnancy: 'Safe in early pregnancy with support',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 104,
      name: 'Ring Roll Down',
      description: 'Stand with feet hip-width apart, holding ring in front. Roll down through spine while reaching ring forward and down.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['back', 'flexibility', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust grip on ring for comfort',
        back: 'Bend knees and reduce range of motion',
        knee: 'Keep knees soft throughout movement',
        shoulder: 'Keep shoulders relaxed away from ears',
        pregnancy: 'Widen stance and reduce range in later stages',
        balance: 'Stand near wall for support if needed'
      },
      image: '⤵️'
    },
    {
      id: 105,
      name: 'Ring Bridge',
      description: 'Lie on back with knees bent, ring between inner thighs. Perform bridge while squeezing ring, then lower with control.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['glutes', 'inner thighs', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce height of bridge if back is sensitive',
        knee: 'Position feet for knee comfort',
        shoulder: 'Keep arms relaxed at sides',
        pregnancy: 'Safe in early pregnancy, adjust in later stages',
        balance: 'No specific modification needed'
      },
      image: '🌉'
    },
    {
      id: 106,
      name: 'Hamstring Curls with Ring',
      description: 'Lie on stomach with ring between heels. Bend knees to bring heels toward glutes while maintaining pressure on ring.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['hamstrings', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Support head comfortably with stacked hands',
        back: 'Keep hips pressed into mat',
        knee: 'Reduce range of knee bend if needed',
        shoulder: 'Keep shoulders relaxed and away from ears',
        pregnancy: 'Not recommended',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 107,
      name: 'Foam Roller Shoulder Bridge',
      description: 'Lie with foam roller vertically along spine, knees bent. Perform small pelvic tilts while balancing on roller.',
      equipment: ['foam_roller'],
      duration: 2,
      targetAreas: ['core', 'back', 'balance'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Position arms for balance and comfort',
        back: 'Use half roller or place roller horizontal if very sensitive',
        knee: 'Position feet for knee comfort',
        shoulder: 'Keep shoulders relaxed and down',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Practice near wall for safety'
      },
      image: '🌉'
    },
    {
      id: 108,
      name: 'Foam Roller Snow Angels',
      description: 'Lie with foam roller vertically along spine. Perform arm arcs like snow angels while maintaining balance.',
      equipment: ['foam_roller'],
      duration: 2,
      targetAreas: ['back', 'core', 'shoulders'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Place roller horizontally under upper back instead',
        knee: 'Position feet firmly for stability',
        shoulder: 'Reduce range of arm movement if needed',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Keep feet planted firmly for stability'
      },
      image: '👼'
    },
    {
      id: 109,
      name: 'Foam Roller Hamstring Release',
      description: 'Sit with foam roller under thighs. Roll slowly from sit bones to knees, pausing at tight spots.',
      equipment: ['foam_roller'],
      duration: 3,
      targetAreas: ['hamstrings', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Support weight through arms comfortably',
        back: 'Maintain neutral spine',
        knee: 'Avoid rolling directly over knee joint',
        shoulder: 'Keep shoulders relaxed and away from ears',
        pregnancy: 'Safe in early pregnancy, avoid in later stages',
        balance: 'Use hands for stability'
      },
      image: '🦵'
    },
    {
      id: 110,
      name: 'Foam Roller Core Challenge',
      description: 'Lie with foam roller vertically along spine, arms and legs extended to ceiling. Lower opposite arm and leg with control.',
      equipment: ['foam_roller'],
      duration: 3,
      targetAreas: ['core', 'balance'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep movements small and controlled',
        knee: 'Bend knees slightly for stability',
        shoulder: 'Reduce arm range if shoulders are tight',
        pregnancy: 'Not recommended',
        balance: 'Start with just arm movements before adding legs'
      },
      image: '🔄'
    },
    {
      id: 111,
      name: 'Foam Roller Thoracic Extension',
      description: 'Lie with foam roller horizontally under upper back, hands supporting head. Gently extend spine over roller, then return.',
      equipment: ['foam_roller'],
      duration: 2,
      targetAreas: ['back', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Support head comfortably',
        back: 'Reduce range of extension if uncomfortable',
        knee: 'Keep feet firmly planted for stability',
        shoulder: 'Support head to avoid neck tension',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Keep movements slow and controlled'
      },
      image: '⤴️'
    },
    {
      id: 112,
      name: 'Ab Prep with Weights',
      description: 'Lie on back, knees bent, holding light weights at shoulders. Perform chest lift with arms reaching forward.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['core', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weights if wrists are sensitive',
        back: 'Lift just head and shoulders if back is sensitive',
        knee: 'No specific modification needed',
        shoulder: 'Keep neck long, avoid tension',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🏋️'
    },
    {
      id: 113,
      name: 'Side-Lying Leg Series with Weights',
      description: 'Lie on side with ankle weight on top leg. Perform leg lifts, circles, and beats with added resistance.',
      equipment: ['weights'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head comfortably to avoid wrist strain',
        back: 'Keep spine neutral and hips stacked',
        knee: 'Reduce range of motion if knee is sensitive',
        shoulder: 'Support head with pillow if needed',
        pregnancy: 'Safe in early pregnancy with support',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 114,
      name: 'Tricep Kickbacks',
      description: 'Kneel with one leg forward, opposite arm holding weight. Extend arm back with control, engaging triceps.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['arms', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust wrist position for comfort',
        back: 'Keep spine neutral with core engaged',
        knee: 'Use padding under supporting knee',
        shoulder: 'Keep shoulder blade stable during movement',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'Support free hand on stable surface'
      },
      image: '💪'
    },
    {
      id: 115,
      name: 'Pilates Lunge with Bicep Curl',
      description: 'Perform forward lunge while holding weights, adding bicep curl at bottom of lunge.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['legs', 'arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weights if wrists are sensitive',
        back: 'Keep spine neutral throughout',
        knee: 'Adjust lunge depth for knee comfort',
        shoulder: 'Keep shoulders relaxed away from ears',
        pregnancy: 'Reduce range in later stages',
        balance: 'Stand near wall for support if needed'
      },
      image: '🏋️'
    },
    {
      id: 116,
      name: 'Swimming with Weights',
      description: 'Lie on stomach with light weights in hands. Lift opposite arm and leg, alternating in swimming motion with added resistance.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['back', 'shoulders', 'glutes'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Use lighter weights if wrists are sensitive',
        back: 'Lift limbs lower if back is sensitive',
        knee: 'Reduce leg lift height if needed',
        shoulder: 'Keep neck in line with spine, look down',
        pregnancy: 'Not recommended',
        balance: 'Start with just arms or just legs before combining'
      },
      image: '🏊'
    },
    {
      id: 117,
      name: 'Squat with Rotation',
      description: 'Perform squat while holding weight at chest height. Add torso rotation at bottom of squat, then return to center as you rise.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['legs', 'core', 'obliques'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weight if wrists are sensitive',
        back: 'Reduce squat depth and rotation range',
        knee: 'Adjust squat depth for knee comfort',
        shoulder: 'Keep shoulders relaxed and engaged',
        pregnancy: 'Reduce range and avoid in later stages',
        balance: 'Stand near wall for support if needed'
      },
      image: '🔄'
    },
    {
      id: 118,
      name: 'Arm Scissors with Weights',
      description: 'Stand with feet hip-width apart, holding weights. Perform scissor-like movements with arms at shoulder height.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['shoulders', 'arms', 'core'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Use lighter weights if wrists are sensitive',
        back: 'Keep core engaged to support back',
        knee: 'Stand with soft knees for stability',
        shoulder: 'Reduce range of motion and use lighter weights',
        pregnancy: 'Safe in early pregnancy with lighter weights',
        balance: 'Stand near wall for support if needed'
      },
      image: '✂️'
    },
    {
      id: 119,
      name: 'Mermaid with Weights',
      description: 'Sit with legs folded to side, holding weight in upper hand. Perform side bend with weight, then return to start.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['obliques', 'arms', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weight if wrists are sensitive',
        back: 'Reduce range of side bend if back is sensitive',
        knee: 'Adjust leg position for comfort',
        shoulder: 'Keep shoulders relaxed, avoid hiking up',
        pregnancy: 'Adjust position to make room for belly',
        balance: 'Use free hand for support if needed'
      },
      image: '🧜‍♀️'
    },
    {
      id: 120,
      name: 'Kneeling Side Kick with Weights',
      description: 'Kneel on one knee with ankle weight on opposite leg. Extend weighted leg to side with control.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support weight through hand comfortably',
        back: 'Keep spine neutral with core engaged',
        knee: 'Place cushion under supporting knee',
        shoulder: 'Keep supporting shoulder engaged and stable',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Place hand on wall for support if needed'
      },
      image: '🦵'
    },
    {
      id: 121,
      name: 'Tower Standing Arm Spring Series',
      description: 'Stand facing tower/cadillac, holding springs at shoulder height. Perform various arm patterns including press, pull, and circles.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['arms', 'shoulders', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on springs for comfort',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Stand with soft knees for stability',
        shoulder: 'Reduce range of motion and use lighter spring tension',
        pregnancy: 'Safe in early pregnancy with appropriate adjustments',
        balance: 'Stand closer to tower for stability'
      },
      image: '🏋️'
    },
    {
      id: 122,
      name: 'Tower Lunges with Springs',
      description: 'Face away from tower/cadillac, holding springs at shoulder height. Perform lunges with arm movements against spring resistance.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['legs', 'arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on springs for comfort',
        back: 'Keep spine neutral throughout movement',
        knee: 'Adjust lunge depth based on knee comfort',
        shoulder: 'Reduce arm range if shoulders are sensitive',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Take smaller steps for stability'
      },
      image: '🏃'
    },
    {
      id: 123,
      name: 'Tower Side-Lying Hip Work',
      description: 'Lie on side with top leg in tower/cadillac leg spring. Perform forward kicks, side lifts, and circles against resistance.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Support head comfortably to reduce wrist strain',
        back: 'Keep spine neutral and hips stacked',
        knee: 'Adjust spring position and range for knee comfort',
        shoulder: 'Support head with pillow if needed',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '🦵'
    },
    {
      id: 124,
      name: 'Tower Teaser Pull',
      description: 'Sit facing tower/cadillac with springs in hands. Simultaneously roll back and extend legs while pulling springs overhead.',
      equipment: ['tower'],
      duration: 3,
      targetAreas: ['core', 'arms', 'flexibility'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust grip on springs for comfort',
        back: 'Keep feet on ground or knees bent if back is sensitive',
        knee: 'Bend knees if hamstrings are tight',
        shoulder: 'Reduce range of overhead motion if shoulders are tight',
        pregnancy: 'Not recommended',
        balance: 'Practice roll back and leg extension separately first'
      },
      image: '🔺'
    },
    {
      id: 125,
      name: 'Tower Twist',
      description: 'Kneel sideways to tower/cadillac, holding spring with outside hand. Rotate torso against spring resistance.',
      equipment: ['tower'],
      duration: 2,
      targetAreas: ['core', 'obliques', 'arms'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on spring for comfort',
        back: 'Reduce rotation range if back is sensitive',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulder blades engaged, avoid shrugging',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Place free hand on floor for stability if needed'
      },
      image: '🔄'
    },
    {
      id: 126,
      name: 'Split Pedal Pushes',
      description: 'Stand on reformer with one foot on each side of the foot bar. Push carriage out and in with alternating foot pressure.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['legs', 'core', 'balance'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep spine neutral with core engaged',
        knee: 'Reduce range if knees are sensitive',
        shoulder: 'Use reformer straps for upper body support if needed',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Use appropriate spring tension for stability'
      },
      image: '🦵'
    },
    {
      id: 127,
      name: 'Twist with Circles',
      description: 'Sit sideways on reformer carriage, holding one strap. Circle arm while maintaining rotated position.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['arms', 'core', 'obliques'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on strap for comfort',
        back: 'Sit on cushion and reduce rotation if back is sensitive',
        knee: 'Position legs for comfort',
        shoulder: 'Make smaller circles if shoulder is sensitive',
        pregnancy: 'Safe in early pregnancy with adjusted position',
        balance: 'Use appropriate spring tension for stability'
      },
      image: '⭕'
    },
    {
      id: 128,
      name: 'Knee Stretch Series on Wunda Chair',
      description: 'Kneel on chair seat with hands on pedal. Press pedal down and up with straight arms in various back positions.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['core', 'arms', 'back'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Adjust hand position or use fists if wrists are sensitive',
        back: 'Reduce range of spinal positions if back is sensitive',
        knee: 'Use padding under knees',
        shoulder: 'Keep shoulders engaged and away from ears',
        pregnancy: 'Not recommended',
        balance: 'Use appropriate spring setting for stability'
      },
      image: '🧎'
    },
    {
      id: 129,
      name: 'Split Pedal Lunges on Chair',
      description: 'Stand with one foot on chair pedal, other on floor. Press pedal down into lunge, then return.',
      equipment: ['chair'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep spine neutral with core engaged',
        knee: 'Control range to avoid knee strain',
        shoulder: 'Hold chair for stability if needed',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Hold onto stable support for balance'
      },
      image: '🏃'
    },
    {
      id: 130,
      name: 'Spine Curl with Band',
      description: 'Lie on back with band around mid-thighs, knees bent. Press knees outward against band while performing pelvic curl.',
      equipment: ['band'],
      duration: 2,
      targetAreas: ['core', 'glutes', 'inner thighs'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep curl range small if back is sensitive',
        knee: 'Position feet for knee comfort',
        shoulder: 'Keep arms relaxed at sides',
        pregnancy: 'Safe in early pregnancy, adjust in later stages',
        balance: 'No specific modification needed'
      },
      image: '🌊'
    },
    {
      id: 131,
      name: 'Heel Beats on Reformer',
      description: 'Lie on back on reformer with legs in straps. Perform small, rapid beating movements with legs against spring tension.',
      equipment: ['reformer'],
      duration: 2,
      targetAreas: ['legs', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Keep lower back pressed into carriage',
        knee: 'Reduce range if knees are sensitive',
        shoulder: 'Keep shoulders relaxed on carriage',
        pregnancy: 'Not recommended after first trimester',
        balance: 'No specific modification needed'
      },
      image: '👣'
    },
    {
      id: 132,
      name: 'Side Overs on Ladder Barrel',
      description: 'Stand side-facing to ladder barrel, extend arm overhead and perform side bend over barrel.',
      equipment: ['tower'],
      duration: 2,
      targetAreas: ['obliques', 'flexibility', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust arm position for comfort',
        back: 'Reduce bending range if back is sensitive',
        knee: 'Stand with slight knee bend for stability',
        shoulder: 'Keep extending arm relaxed if shoulder is tight',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Hold barrel with free hand for stability'
      },
      image: '↪️'
    },
    {
      id: 133,
      name: 'Forward Stretch on Ladder Barrel',
      description: 'Sit on ladder barrel with legs extended along or off barrel. Hinge forward for deep hamstring and back stretch.',
      equipment: ['tower'],
      duration: 2,
      targetAreas: ['back', 'hamstrings', 'flexibility'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce forward bend if back is sensitive',
        knee: 'Bend knees slightly if hamstrings are tight',
        shoulder: 'Let arms hang naturally, avoid tension',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Hold barrel for stability if needed'
      },
      image: '⤵️'
    },
    {
      id: 134,
      name: 'Backstroke on Reformer',
      description: 'Lie on back on reformer holding straps. Perform arm circles mimicking backstroke swimming motion against spring resistance.',
      equipment: ['reformer'],
      duration: 2,
      targetAreas: ['arms', 'chest', 'back', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Adjust grip on straps for comfort',
        back: 'Keep lower back pressed into carriage',
        knee: 'No specific modification needed',
        shoulder: 'Reduce range of motion if shoulders are sensitive',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'No specific modification needed'
      },
      image: '🏊'
    },
    {
      id: 135,
      name: 'Figure 4 Stretch with Ring',
      description: 'Lie on back with ankle crossed over opposite knee in figure 4 position. Place ring between hands and extended knee for assisted stretch.',
      equipment: ['ring'],
      duration: 2,
      targetAreas: ['glutes', 'hips', 'flexibility'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'Adjust hand position on ring for comfort',
        back: 'Keep low back pressed to mat',
        knee: 'Reduce depth of stretch if knee is sensitive',
        shoulder: 'Keep shoulders relaxed on mat',
        pregnancy: 'Safe in early pregnancy with adjusted leg position',
        balance: 'No specific modification needed'
      },
      image: '4️⃣'
    },
    {
      id: 136,
      name: 'Spine Twist with Ball',
      description: 'Sit on exercise ball with feet planted. Rotate torso side to side while maintaining stable base.',
      equipment: ['ball'],
      duration: 2,
      targetAreas: ['core', 'obliques', 'balance'],
      difficulty: 'beginner',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Reduce rotation range if back is sensitive',
        knee: 'Position feet securely for stability',
        shoulder: 'Keep shoulders relaxed away from ears',
        pregnancy: 'Safe in early pregnancy with appropriate positioning',
        balance: 'Place ball against wall for initial stability'
      },
      image: '🔄'
    },
    {
      id: 137,
      name: 'Skater on Reformer',
      description: 'Stand on reformer carriage with one foot, other leg extended back. Bend standing leg and extend arms forward like speed skater.',
      equipment: ['reformer'],
      duration: 3,
      targetAreas: ['legs', 'glutes', 'balance', 'core'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'No specific modification needed',
        back: 'Maintain neutral spine with core engaged',
        knee: 'Reduce depth of bend if knee is sensitive',
        shoulder: 'Keep shoulders down and back',
        pregnancy: 'Not recommended',
        balance: 'Hold reformer frame for support initially'
      },
      image: '⛸️'
    },
    {
      id: 138,
      name: 'Chest Expansion with Weights',
      description: 'Stand with feet hip-width apart, holding weights at sides. Rotate torso while extending arms back in rowing motion.',
      equipment: ['weights'],
      duration: 2,
      targetAreas: ['back', 'arms', 'core'],
      difficulty: 'intermediate',
      modifications: {
        wrist: 'Use lighter weights if wrists are sensitive',
        back: 'Reduce rotation range if back is sensitive',
        knee: 'Stand with soft knees for stability',
        shoulder: 'Reduce range of motion and use lighter weights',
        pregnancy: 'Safe in early pregnancy with appropriate adjustments',
        balance: 'Stand near wall for support if needed'
      },
      image: '🏹'
    },
    {
      id: 139,
      name: 'Shoulder Stability Series',
      description: 'Kneel with hands on foam roller horizontally on mat. Maintain stability while performing small arm movements.',
      equipment: ['foam_roller'],
      duration: 2,
      targetAreas: ['shoulders', 'core', 'balance'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Place hands on highest stable point of roller',
        back: 'Keep spine neutral with core engaged',
        knee: 'Use padding under knees',
        shoulder: 'Reduce movement range if shoulders are sensitive',
        pregnancy: 'Not recommended after second trimester',
        balance: 'Start with roller on stable surface before floor'
      },
      image: '💪'
    },
    {
      id: 140,
      name: 'Full Body Integration',
      description: 'A flowing sequence combining breath with coordinated arm and leg movements while transitioning between positions.',
      equipment: ['none'],
      duration: 5,
      targetAreas: ['fullbody', 'core', 'flexibility', 'balance'],
      difficulty: 'advanced',
      modifications: {
        wrist: 'Modify hand positions as needed throughout sequence',
        back: 'Reduce range of motion and maintain core engagement',
        knee: 'Adapt transitions to accommodate knee sensitivity',
        shoulder: 'Modify arm positions to respect shoulder limitations',
        pregnancy: 'Not recommended after first trimester',
        balance: 'Simplify transitions and stay near wall if needed'
      },
      image: '🌟'
    }
  ];

  export default exerciseDatabase;